import { useState } from 'react';

/**
 * Custom hook to manage onboarding state
 * Checks localStorage to determine if user has completed onboarding
 */
const useOnboarding = () => {
  const [showOnboarding, setShowOnboarding] = useState(() => {
    // Check localStorage on initial load - TRUE one-time login
    const onboardingComplete = localStorage.getItem('pwaOnboardingComplete');
    const savedEmail = localStorage.getItem('submittedOnBehalfOf');
    return !onboardingComplete && !savedEmail; // Only show if NOT completed
  });

  /**
   * Mark onboarding as complete and save user email
   * @param {string} email - User's PyeBarkerFS email
   */
  const completeOnboarding = (email) => {
    setShowOnboarding(false);
    // Note: OnboardingWizard already saves to localStorage,
    // but we keep this centralized for consistency
  };

  /**
   * Check if onboarding is complete (from localStorage)
   * @returns {boolean} - True if onboarding is complete
   */
  const isOnboardingComplete = () => {
    const onboardingComplete = localStorage.getItem('pwaOnboardingComplete');
    const savedEmail = localStorage.getItem('submittedOnBehalfOf');
    return !!(onboardingComplete || savedEmail);
  };

  return {
    showOnboarding,
    setShowOnboarding,
    completeOnboarding,
    isOnboardingComplete
  };
};

export default useOnboarding;


